import _taggedTemplateLiteral from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      :host {\n        display: inline-block;\n        position: relative;\n        width: 300px;\n        box-sizing: border-box;\n      }\n      :host([disabled]) {\n        opacity: 0.45 !important;\n        cursor: default;\n        pointer-events: none;\n        background: rgba(0, 0, 0, 0.07);\n        border-radius: 5px;\n      }\n      input[type=range] {\n        width: 100%;\n        height: 40px;\n        box-sizing: border-box;\n        margin: 0;\n        -webkit-appearance: none;\n        background: transparent;\n        outline: none;\n        position: relative;\n      }\n      input[type=range]:focus {\n        outline: none;\n      }\n      input[type=range]::-ms-track {\n        width: 100%;\n        cursor: pointer;\n        background: transparent;\n        border-color: transparent;\n        color: transparent;\n      }\n      input[type=range]::-moz-focus-outer {\n        outline: none;\n        border: 0;\n      }\n      input[type=range]::-moz-range-thumb {\n        border-radius: 50px;\n        background: none;\n        cursor: pointer;\n        border: none;\n        margin: 0;\n        height: 20px;\n        width: 20px;\n        line-height: 1;\n      }\n      input[type=range]::-webkit-slider-thumb {\n        -webkit-appearance: none;\n        border-radius: 50px;\n        background: none;\n        cursor: pointer;\n        border: none;\n        height: 20px;\n        width: 20px;\n        margin: 0;\n        line-height: 1;\n      }\n      .knob{\n        fill: var(--wired-slider-knob-color, rgb(51, 103, 214));\n        stroke: var(--wired-slider-knob-color, rgb(51, 103, 214));\n      }\n      .bar {\n        stroke: var(--wired-slider-bar-color, rgb(0, 0, 0));\n      }\n      input:focus + div svg .knob {\n        stroke: var(--wired-slider-knob-outline-color, #000);\n        fill-opacity: 0.8;\n      }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <div id=\"container\">\n      <input type=\"range\" \n        min=\"", "\"\n        max=\"", "\"\n        step=\"", "\"\n        ?disabled=\"", "\"\n        @input=\"", "\">\n      <div id=\"overlay\">\n        <svg></svg>\n      </div>\n    </div>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { WiredBase, BaseCSS, fire } from 'wired-lib/lib/wired-base';
import { customElement, property, query, css, html } from 'lit-element';
import { line, ellipse } from 'wired-lib';

var WiredSlider = /*#__PURE__*/function (_WiredBase) {
  _inherits(WiredSlider, _WiredBase);

  var _super = _createSuper(WiredSlider);

  function WiredSlider() {
    var _this;

    _classCallCheck(this, WiredSlider);

    _this = _super.apply(this, arguments);
    _this.min = 0;
    _this.max = 100;
    _this.step = 1;
    _this.disabled = false;
    _this.canvasWidth = 300;
    return _this;
  }

  _createClass(WiredSlider, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      this.value = this.pendingValue || +(this.getAttribute('value') || this.value || this.min);
      delete this.pendingValue;
    }
  }, {
    key: "render",
    value: function render() {
      return html(_templateObject(), this.min, this.max, this.step, this.disabled, this.onInput);
    }
  }, {
    key: "focus",
    value: function focus() {
      if (this.input) {
        this.input.focus();
      } else {
        _get(_getPrototypeOf(WiredSlider.prototype), "focus", this).call(this);
      }
    }
  }, {
    key: "onInput",
    value: function onInput(e) {
      e.stopPropagation();
      this.updateThumbPosition();

      if (this.input) {
        fire(this, 'change', {
          value: +this.input.value
        });
      }
    }
  }, {
    key: "wiredRender",
    value: function wiredRender() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _get(_getPrototypeOf(WiredSlider.prototype), "wiredRender", this).call(this, force);

      this.updateThumbPosition();
    }
  }, {
    key: "canvasSize",
    value: function canvasSize() {
      var s = this.getBoundingClientRect();
      return [s.width, s.height];
    }
  }, {
    key: "draw",
    value: function draw(svg, size) {
      this.canvasWidth = size[0];
      var midY = Math.round(size[1] / 2);
      line(svg, 0, midY, size[0], midY, this.seed).classList.add('bar');
      this.knob = ellipse(svg, 10, midY, 20, 20, this.seed);
      this.knob.classList.add('knob');
    }
  }, {
    key: "updateThumbPosition",
    value: function updateThumbPosition() {
      if (this.input) {
        var value = +this.input.value;
        var delta = Math.max(this.step, this.max - this.min);
        var pct = (value - this.min) / delta;

        if (this.knob) {
          this.knob.style.transform = "translateX(".concat(pct * (this.canvasWidth - 20), "px)");
        }
      }
    }
  }, {
    key: "value",
    get: function get() {
      if (this.input) {
        return +this.input.value;
      }

      return this.min;
    },
    set: function set(v) {
      if (this.input) {
        this.input.value = "".concat(v);
      } else {
        this.pendingValue = v;
      }

      this.updateThumbPosition();
    }
  }], [{
    key: "styles",
    get: function get() {
      return [BaseCSS, css(_templateObject2())];
    }
  }]);

  return WiredSlider;
}(WiredBase);

__decorate([property({
  type: Number
}), __metadata("design:type", Object)], WiredSlider.prototype, "min", void 0);

__decorate([property({
  type: Number
}), __metadata("design:type", Object)], WiredSlider.prototype, "max", void 0);

__decorate([property({
  type: Number
}), __metadata("design:type", Object)], WiredSlider.prototype, "step", void 0);

__decorate([property({
  type: Boolean,
  reflect: true
}), __metadata("design:type", Object)], WiredSlider.prototype, "disabled", void 0);

__decorate([query('input'), __metadata("design:type", HTMLInputElement)], WiredSlider.prototype, "input", void 0);

WiredSlider = __decorate([customElement('wired-slider')], WiredSlider);
export { WiredSlider };